<template>
  <div class="goods-info">
    <div class="goods-info-header">
      <div :class="labelClass">&nbsp;</div>
      <div :class="titleClass">{{ $t('SeaExport.Quantity') }}</div>
      <div :class="titleClass">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
      <div :class="titleClass">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
      <div :class="titleClass">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
      <div :class="titleClass">{{ $t('queryJob.Density') }}kg/m³</div>
      <div :class="titleClass">{{ $t('SeaExport.Size') }}CM</div>
    </div>
    <div v-if="displayConfig.goodsInfoContract" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.Consignation')" />
      <auto-number-input
        v-model="job.quantityContract"
        :disabled="disabled"
        no="quantityContract"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onNumberChange('quantityContract')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.weightContractImperial"
        :disabled="disabled"
        no="weightContractImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightContractImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cubAgeContractImperial"
        :disabled="disabled"
        no="cubAgeContractImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubAgeContractImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.chargeWeightImperial"
        no="chargeWeightImperial"
        :precision="3"
        :min="0"
        :disabled="true"
        @change="onNumberChange('chargeWeightImperial')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.weightContract"
        :disabled="disabled"
        no="weightContract"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightContract')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cubageContract"
        :disabled="disabled"
        no="cubageContract"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubageContract')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.chargeWeight"
        :disabled="disabled"
        no="chargeWeight"
        :precision="3"
        :min="0"
        @change="chargeWeightImperialChange('chargeWeight', 'chargeWeightImperial')"
      />
      <auto-number-input
        v-model="job.densityContract"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densityContract"
        @change="onNumberChange('densityContract')"
      />
      <el-input v-model="job.commissionDimensions" :disabled="disabled" @change="onChange('commissionDimensions')" />
    </div>
    <div v-if="displayConfig.goodsInfoBooking" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.Booking')" />
      <auto-number-input
        v-model="job.quantityBooking"
        :disabled="disabled"
        no="quantityBooking"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onNumberChange('quantityBooking')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.weightBookingImperial"
        :disabled="disabled"
        no="weightBookingImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightBookingImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cubAgeBookingImperial"
        :disabled="disabled"
        no="cubAgeBookingImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubAgeBookingImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.chargeWeightBookingImperial"
        no="chargeWeightBookingImperial"
        :precision="3"
        :min="0"
        :disabled="true"
        @change="onNumberChange('chargeWeightBookingImperial')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.weightBooking"
        :disabled="disabled"
        no="weightBooking"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightBooking')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cubageBooking"
        :disabled="disabled"
        no="cubageBooking"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubageBooking')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.chargeWeightBooking"
        :disabled="disabled"
        no="chargeWeightBooking"
        :precision="3"
        :min="0"
        @change="chargeWeightImperialChange('chargeWeightBooking', 'chargeWeightBookingImperial')"
      />
      <auto-number-input
        v-model="job.densityBooking"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densityBooking"
        @change="onNumberChange('densityBooking')"
      />
      <el-input v-model="job.measurements" :disabled="disabled" @change="onChange('measurements')" />
    </div>
    <div v-if="displayConfig.goodsInfoActual" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.FrontCabinActual')" />
      <auto-number-input
        v-model="job.quantityActual"
        :disabled="disabled"
        no="quantityActual"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onNumberChange('quantityActual')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.weightActualImperial"
        :disabled="disabled"
        no="weightActualImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightActualImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cubAgeActualImperial"
        :disabled="disabled"
        no="cubAgeActualImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubAgeActualImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cWeightImperial"
        no="cWeightImperial"
        :precision="3"
        :min="0"
        :disabled="true"
        @change="onNumberChange('cWeightImperial')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.weightActual"
        :disabled="disabled"
        no="weightActual"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightActual')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cubageActual"
        :disabled="disabled"
        no="cubageActual"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubageActual')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cWeight"
        :disabled="disabled"
        no="cWeight"
        :precision="3"
        :min="0"
        @change="onNumberChange('cWeight')"
      />
      <auto-number-input
        v-model="job.densityActual"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densityActual"
        @change="onNumberChange('densityActual')"
      />
      <el-input v-model="job.dimensionsActual" :disabled="disabled" @change="onChange('dimensionsActual')" />
    </div>
    <div v-if="displayConfig.quantityStation" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.FreightStation')" />
      <auto-number-input
        v-model="job.quantityStation"
        :disabled="disabled"
        no="quantityStation"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onNumberChange('quantityStation')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.weightStationImperial"
        :disabled="disabled"
        no="weightStationImperial"
        :precision="2"
        :min="0"
        @change="onNumberChange('weightStationImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cubAgeStationImperial"
        :disabled="disabled"
        no="cubAgeStationImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubAgeStationImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.chargeWeightStationImperial"
        no="chargeWeightStationImperial"
        :precision="3"
        :min="0"
        :disabled="true"
        @change="onNumberChange('chargeWeightStationImperial')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.weightStation"
        :disabled="disabled"
        no="weightStation"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightStation')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cubageStation"
        :disabled="disabled"
        no="cubageStation"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubageStation')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.chargeWeightStation"
        :disabled="disabled"
        no="chargeWeightStation"
        :precision="3"
        :min="0"
        @change="chargeWeightImperialChange('chargeWeightStation', 'chargeWeightStationImperial')"
      />
      <auto-number-input
        v-model="job.densityStation"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densityStation"
        @change="onNumberChange('densityStation')"
      />
      <el-input v-model="job.freightStationDimensions" :disabled="disabled" @change="onChange('freightStationDimensions')" />
    </div>
    <div v-if="displayConfig.quantitySigning" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.SignBill')" />
      <auto-number-input
        v-model="job.quantitySigning"
        :disabled="disabled"
        no="quantitySigning"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onNumberChange('quantitySigning')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.weightSigningImperial"
        :disabled="disabled"
        no="weightSigningImperial"
        :precision="2"
        :min="0"
        @change="onNumberChange('weightSigningImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.cubAgeSigningImperial"
        :disabled="disabled"
        no="cubAgeSigningImperial"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubAgeSigningImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="job.chargeWeightSigningImperial"
        no="chargeWeightSigningImperial"
        :precision="3"
        :min="0"
        :disabled="true"
        @change="onNumberChange('chargeWeightSigningImperial')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.weightSigning"
        :disabled="disabled"
        no="weightSigning"
        :precision="3"
        :min="0"
        @change="onNumberChange('weightSigning')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.cubageSigning"
        :disabled="disabled"
        no="cubageSigning"
        :precision="3"
        :min="0"
        @change="onNumberChange('cubageSigning')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="job.chargeWeightSigning"
        :disabled="disabled"
        no="chargeWeightSigning"
        :precision="3"
        :min="0"
        @change="chargeWeightImperialChange('chargeWeightSigning', 'chargeWeightSigningImperial')"
      />
      <auto-number-input
        v-model="job.densitySigning"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densitySigning"
        @change="onNumberChange('densitySigning')"
      />
      <el-input v-model="job.dimensionsSigning" :disabled="disabled" @change="onChange('dimensionsSigning')" />
    </div>
    <div v-if="displayConfig.goodsInfoDocument && job.operateType!==0" class="goods-info-item">
      <line-label :class="labelClass" :label="$t('SeaExport.Documentation')" />
      <auto-number-input
        v-model="mawbDoc.quantity"
        :disabled="mawbDocDisabled"
        no="102"
        :precision="0"
        :min="0"
        style="margin-left: 0"
        @change="onMawbDocChange('quantity')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="mawbDoc.weightImperial"
        :disabled="mawbDocDisabled"
        no="weightImperial"
        :precision="3"
        :min="0"
        @change="onMawbDocChange('weightImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="mawbDoc.cubAgeImperial"
        :disabled="mawbDocDisabled"
        no="cubAgeImperial"
        :precision="3"
        :min="0"
        @change="onMawbDocChange('cubAgeImperial')"
      />
      <auto-number-input
        v-show="openImperial"
        v-model="mawbDoc.chargeWeightImperial"
        no="chargeWeightImperial"
        :precision="3"
        :min="0"
        :disabled="true"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="mawbDoc.weight"
        :disabled="mawbDocDisabled"
        no="weight"
        :precision="3"
        :min="0"
        @change="onMawbDocChange('weight')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="mawbDoc.cubage"
        :disabled="mawbDocDisabled"
        no="cubage"
        :precision="3"
        :min="0"
        @change="onMawbDocChange('cubage')"
      />
      <auto-number-input
        v-show="!openImperial"
        v-model="mawbDoc.cWeight"
        :disabled="mawbDocDisabled"
        no="cWeight"
        :precision="3"
        :min="0"
        @change="onMawbDocChange('cWeight')"
      />
      <auto-number-input
        v-model="job.densityDoc"
        :disabled="disabled"
        :precision="3"
        :min="0"
        no="densityDoc"
        @change="onNumberChange('densityDoc')"
      />
      <el-input v-model="job.docDimensions" :disabled="disabled" @change="onChange('docDimensions')" />
    </div>
  </div>
</template>

<script>
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'AeBasicGoodsInfo',
  components: {
    AutoNumberInput
  },
  props: {
    job: { type: Object, default: () => { return {} } },
    mawbDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    isRequire: { type: Boolean, default: false },
    openImperial: { type: Boolean, default: false },
    showImperialButton: { type: Boolean, default: false },
    displayConfig: { type: Object, default: () => { return {} } }
  },
  computed: {
    titleClass() {
      return 'title-format' + (this.isRequire ? ' blue' : '')
    },
    labelClass() {
      return 'label-format' + (this.isRequire ? ' blue' : '')
    },
    mawbDocDisabled() {
      return this.disabled || !this.mawbDoc.uuid
    }
  },
  methods: {
    async chargeWeightImperialChange(oldKey, key) {
      this.job[oldKey] = this.job[oldKey] || 0
      if (this.job[oldKey]) {
        this.job[key] = await JobUtils.calculateWeight(this.job[oldKey], true)
      } else {
        this.job[key] = 0
      }
      this.$emit('childrenChange', [{ key: oldKey, value: this.job[oldKey] }, { key, value: this.job[key] }])
    },
    onMawbDocChange(key) {
      this.mawbDoc[key] = this.mawbDoc[key] || 0
      this.$emit('mawbDocChange', [{ key, value: this.mawbDoc[key] }])
    },
    onNumberChange(key) {
      this.job[key] = this.job[key] || 0
      this.onChange(key)
    },
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-info::v-deep {
    width: 1100px;
    display: flex;
    flex-direction: column;
    .goods-info-header {
        display: flex;
        .label-format {
            width: 110px;
            margin-right: 10px;
        }
        .title-format {
            font-size: 12px;
            font-weight: normal;
            color: #404144;
            white-space: nowrap;
            width:190px;
            text-align: right;
            margin-right: 10px;
        }
    }
    .goods-info-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        .label-format {
            width: 110px;
            margin-right: 10px;
        }
        .el-input{
            width: 190px;
            margin-left: 12px;
            text-align: right !important;
        }
    }
}
</style>
